module.exports = __webpack_public_path__ + "static/fonts/icomoon.6ad8682.eot";